export function PerformedRiskActions({uuid}) {
  const [performedRiskActions, setPerformedRiskActions] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState(undefined);
  const [isExpanded, setIsExpanded] = React.useState(false);

  React.useEffect(() => {
    $.ajax({
      url: `/api/transactions/${uuid}/performedRiskActions`,
      dataType: 'json',
      type: 'GET'
    }).done((response) => {
      if (response.status == 200) {
        setPerformedRiskActions(response.data.performedRiskActions);
      } else {
        setErrorMessage(response.message ?? "Unknown error")
      }
    }).fail((unused, textStatus) => {
      setErrorMessage("Error fetching performed risk actions")
    })
  }, []);

  if (errorMessage) {
    return (
      <div className="alert alert-warning inline-exception">
        {errorMessage}
      </div>
    )
  }

  if (performedRiskActions.length === 0) {
    return null;
  }

  return (
    <div className='alert alert-info'>
      <b>Risk timeline</b><br />
      <ul>
        {
          performedRiskActions.map(performedRiskAction => {
            let note = performedRiskAction.note;
            if (performedRiskAction.riskInvestigationUUID) {
              note = <a href={`/risk/investigations/${performedRiskAction.riskInvestigationUUID}`}>{performedRiskAction.note ?? 'Risk investigation'}</a>
            } else if (performedRiskAction.riskAlertUUID) {
              note = <a href={`/risk/alerts/${performedRiskAction.riskAlertUUID}`}>{performedRiskAction.note}</a>
            }

            return (
              <li>
                {moment(performedRiskAction.created).format('YYYY/MM/DD HH:mm')}:&nbsp;
                {performedRiskAction.action.titleize()} - {note} [{performedRiskAction.performedBy?.fullName}]
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}